import { createJsonTranslator } from '../../jsonTranslator/createJsonTranslator';
import en from './en.json';

export type TextKey = keyof typeof en;

export const getText = createJsonTranslator(en);
